import { useEffect, useState, useRef } from "react";
import { reduxForm, InjectedFormProps } from "redux-form";
import { Button, Form, Modal, Message } from "rsuite";
import { Tournament } from "core/models/Tournament";
import ScheduleCommonBracketForm from "components/ScheduleCommonBracket";

interface CommonScheduleProps {
  onClose(): void;
  show: boolean;
  initialValues?: any;
  onSubmit(values: any): void;
  tournament: Tournament | null
}

const handleSubmitFail = () => {
  setTimeout(() => {
    const firstElement = document.getElementsByClassName(
      "rs-error-message-wrapper"
    )[0];
    if (firstElement) {
      firstElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, 50);
};

type FinalProps = InjectedFormProps<{}, CommonScheduleProps> & CommonScheduleProps;

function CommonSchedule({
  onClose,
  show,
  handleSubmit,
  initialValues,
  onSubmit,
  initialize,
  submitFailed,
  invalid,
  tournament,
}: FinalProps) {
  const [formError, setFormError] = useState(false);
  const defaultValues = useRef<any>({});

  useEffect(() => {
    if (initialValues) {
      defaultValues.current = initialValues;
      initialize(initialValues);
    }
  }, [initialValues, initialize]);

  useEffect(() => {
    if (submitFailed) {
      setFormError(invalid);
    }
  }, [submitFailed, invalid]);

  const handleFormSubmit = (values: any) => {
    onSubmit(values);
  };

  return (
    <Modal backdrop="static" onHide={onClose} show={show} size="lg">
      <Modal.Header>
        <Modal.Title>Common Schedule</Modal.Title>
      </Modal.Header>

      {formError && (
        <Message
          type="error"
          description="Fill all required fields before submitting"
        />
      )}

      <Form fluid onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="form-container">
          <ScheduleCommonBracketForm />
        </div>

        <Modal.Footer>
          <Button appearance="primary" type="submit">
            Schedule
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default reduxForm<{}, CommonScheduleProps>({
  form: "common-schedule",
  destroyOnUnmount: true,
  onSubmitFail: handleSubmitFail,
})(CommonSchedule);
